import { combineReducers } from 'redux';
import {
  ADD_PAYOUT,
  CLOSE_CASH_REGISTER,
  FETCH_ACTIVE_REGISTER,
  FETCH_CASH_REGISTER_HISTORY,
  OPEN_CASH_REGISTER,
} from './constants';

const hasActiveRegister = (state = false, action) => {
  switch (action.type) {
    case FETCH_ACTIVE_REGISTER:
    case OPEN_CASH_REGISTER:
      return !!action.payload;
    case CLOSE_CASH_REGISTER:
      return false;
    default:
      return state;
  }
};

const activeRegister = (state = {}, action) => {
  switch (action.type) {
    case ADD_PAYOUT:
      if (action.payload && state.id === action.payload.cashRegisterId) {
        return {
          ...state,
          transactions: [...state.transactions, action.payload],
        };
      }

      return state;
    case FETCH_ACTIVE_REGISTER:
    case OPEN_CASH_REGISTER:
      if (action.payload) {
        return action.payload;
      }
      return state;
    default:
      return state;
  }
};

const transactions = (state = [], action) => {
  switch (action.type) {
    case FETCH_ACTIVE_REGISTER:
    case OPEN_CASH_REGISTER:
      return action.payload.transactions || [];
    case ADD_PAYOUT:
      return [
        ...state,
        action.payload,
      ];
    default:
      return state;
  }
};

const history = (state = [], action) => {
  switch (action.type) {
    case FETCH_CASH_REGISTER_HISTORY:
      return action.payload.rows.map((register) => {
        delete register.transactions;
        return register;
      });
    default:
      return state;
  }
};

export default combineReducers({
  hasActiveRegister,
  activeRegister,
  transactions,
  history,
});
